/* Single frontend version source for every Creative ERP runtime bundle. */
(() => {
  'use strict';
  const BUILD_VERSION = '45.4.7';
  const bootVersion = String(window.frappe?.boot?.creative_theme?.engine_version || '').trim();
  window.CPS_THEME_BUILD_VERSION = BUILD_VERSION;
  window.CPS_THEME_VERSION = bootVersion || BUILD_VERSION;
})();
